import { render, staticRenderFns } from "./LECO_UserDelete.vue?vue&type=template&id=96fdead8&scoped=true&"
import script from "./LECO_UserDelete.vue?vue&type=script&lang=js&"
export * from "./LECO_UserDelete.vue?vue&type=script&lang=js&"
import style0 from "./LECO_UserDelete.vue?vue&type=style&index=0&id=96fdead8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fdead8",
  null
  
)

export default component.exports